<template>
  <div>
    <h2
      v-bind="attributesBinding"
      class="text-center"
      :style="{ height: mainGrammar == 'Preview' ? '26px' : null }"
    >
      {{ currentField.value.ja ? currentField.value.ja : currentField.text }}
    </h2>
    <p
      class="ma-0 text-center text-caption"
      v-if="mainGrammar == 'Preview' && isLanguage !== 'ja'"
    >
      {{ captionText }}
    </p>
  </div>
</template>


<script>
export default {
  name: "Label",
  store: ["main", "mainGrammar", "isLanguage"],
  props: ["currentField"],
  computed: {
    attributesBinding() {
      var attr = {};
      if (this.currentField.id) {
        attr.id = `label-${this.currentField.id}`;
      }
      if (this.currentField.color) {
        attr.style = { color: this.currentField.color };
      }
      return attr;
    },
    captionText() {
      if (!this.currentField.value[this.isLanguage]) {
        return "";
      }
      return this.currentField.value[this.isLanguage];
    },
  },
};
</script>
<style scoped>
::v-deep .v-input__slot {
  min-height: 30px !important;
}
p {
  line-height: 1;
}
h4 {
  user-select: none;
}
</style>
